module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("DRAMATIS PERSONAE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("THE IMPERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Tezozómoc,")]), _vm._v(" a Méxica prince of low repute. The youngest son of the reigning Méxica Emperor Ahuitzotl")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Master Sergeant Lorne "), _c('strong', [_vm._v("Colmuir,")]), _vm._v(" a Skawtish Eagle Knight, the prince’s bodyguard")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Sergeant Leslie "), _c('strong', [_vm._v("Dawd,")]), _vm._v(" a Skawtish Eagle Knight, and the prince’s other bodyguard")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Yacatolli,")]), _vm._v(" "), _c('em', [_vm._v("Tlacateccatl")]), _vm._v(" (Colonel) of the 416th Arrow Knight regiment (motorized)—the “Tarascan Rifles”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("THE CREW OF THE IMN HENRY R. CORNUELLE")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Chu-sa")]), _vm._v(" (Commander) "), _c('strong', [_vm._v("Mitsuharu Hadeishi,")]), _vm._v(" captain")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Sho-sa")]), _vm._v(" (Lieutenant Commander) "), _c('strong', [_vm._v("Susan Koshō,")]), _vm._v(" executive officer")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Thai-i")]), _vm._v(" (Senior Lieutenant, weapons officer) Patrick "), _c('strong', [_vm._v("Hayes")])]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Thai-i")]), _vm._v(" (Senior Lieutenant, engineering) "), _c('strong', [_vm._v("Isoroku")]), _vm._v(" Oushi")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Sho-i")]), _vm._v(" (Midshipman, communications) Daniel "), _c('strong', [_vm._v("Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Thai-i")]), _vm._v(" (Senior Lieutenant, Marine detachment) "), _c('strong', [_vm._v("Huémac")])]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Gunso")]), _vm._v(" (Sergeant) “Hork” "), _c('strong', [_vm._v("Fitzsimmons,")]), _vm._v(" Imperial Marines")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('em', [_vm._v("Heicho")]), _vm._v(" (Corporal) "), _c('strong', [_vm._v("Felix,")]), _vm._v(" Imperial Marines")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Captain’s Steward Kusaru "), _c('strong', [_vm._v("Yejin")])]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Helsdon,")]), _vm._v(" chief machinist’s mate")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("IMPERIAL CITIZENS ON JAGAN")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Itzpalicue")]), _vm._v(" (Skirt-of-Knives), agent of the Mirror Which Reveals The Truth")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Mrs. Greta Hauksbee "), _c('strong', [_vm._v("Petrel,")]), _vm._v(" wife of the Imperial Resident on Jagan")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Soumake,")]), _vm._v(" Imperial attaché in charge of Antiquities, Jagan")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Johann "), _c('strong', [_vm._v("Gemmilsky,")]), _vm._v(" Polish expatriate, riding lizard trader")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("THE HONORABLE CHARTERED COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Doctor "), _c('strong', [_vm._v("Gretchen")]), _vm._v(" Anderssen, xenoarchaeologist, mother of three")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("David "), _c('strong', [_vm._v("Parker,")]), _vm._v(" Company Pilot, assigned to Anderssen’s analysis team")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Magdalena,")]), _vm._v(" Hesht communications and systems expert, also assigned to")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_vm._v("Anderssen’s analysis team")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("THE JEHANAN")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Bhrigu,")]), _vm._v(" "), _c('em', [_vm._v("kujen")]), _vm._v(" of Parus, lord of the Seven Rivers")]), _vm._v(" "), _c('p', {
    staticClass: "indentx"
  }, [_c('strong', [_vm._v("Bhāzuradeha,")]), _vm._v(" a poetess, client of the "), _c('em', [_vm._v("kujen")]), _vm._v(" Bhrigu")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3680cda9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter005.vue
// module id = 84
// module chunks = 0